import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { CommonEventService } from '../services/common-event.service';
// import { DomSanitizer } from '@angular/platform-browser';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { Configuration } from '../config/configuration';

//const uuidv1 = require('uuid/v1');
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  portalUrl = Configuration.portalUrl
  oneFlowUrl = Configuration.oneFlowUrl
  scaBomUrl = Configuration.scaBomUrl
  REST_API_SERVER = Configuration.REST_API_SERVER
  Guest_Email_Url = Configuration.Guest_Email_Url
  Pcb_Quote_Url = Configuration.Pcb_Quote_Url
  MAIN_URL = Configuration.MAIN_URL
  backendStagingServer = Configuration.backendStagingServer
  sierraStandardProductLink = Configuration.sierraStandardProductLink
  AppLocationBaseURL = Configuration.AppLocationBaseURL
  ADDRESS_REQUEST_URL = Configuration.ADDRESS_REQUEST_URL
  Order_Url = Configuration.Order_Url
  autoBOMFileDownloadUrl = Configuration.autoBOMFileDownloadUrl
  scaBOMFileDownloadUrl = Configuration.scaBOMFileDownloadUrl
  Pcb_Specification_URL = Configuration.Pcb_Specification_URL
  Via_In_Pad_URL = Configuration.Via_In_Pad_URL
  Terms_And_Conditions_URL = Configuration.Terms_And_Conditions_URL
  Customer_Care_URL = Configuration.Customer_Care_URL
  FAQ_URL = Configuration.FAQ_URL
  QA_ORDER_URL = Configuration.QA_ORDER_URL
  stagOneflowUrl = Configuration.stagOneflowUrl
  resaleCertiUrl = Configuration.resaleCertiUrl
  customQuoteUrl = Configuration.customQuoteUrl
  fpHpcBaseUrl = Configuration.fpHpcBaseUrl
  public apiMainObj:any = {
    //Sreedhar Variables Start
    httpOptions :{},
    FEMS_accessToken:'',
    authorization:'',
    designPackageName:'',
    countryList :'',
    stateList : '',
    cityList : '',
    defaultCountry : '',
    defaultState : '',
    defaultCity : '',
    state_name : '',
    state_code : '',
    address_type_id : '',
    isShippingChecked: false,
    isBillingChecked: false,
    isDesignerChecked: false,
    contact_company : '',
    contact_first_name : '',
    contact_last_name : '',
    contact_email : '',
    contact_address1 : '',
    contact_address2 : '',
    contact_country : '',
    contact_state : '',
    contact_city : '',
    contact_zipcode : '',
    contact_phone : '',
    alladdress :[],
    selectedBillingAddress : {},
    selectedShippingAddress : {},
    selectedDesignerAddress : {},
    shippingAddressPopup : false,
    billingAddressPopup: false,
    designerAddressPopup: false,
    addressBookName : '',
    address_id : '',
    default_add_address:'',
    contact_user_id:'',
    addressEditPopup: false,
    addressAction:'',
    addressBtnText:'',
    //Sreedhar Variables End
    fileUploadedDataT:{},
    encUrlData :{}
  }
  

  constructor(private httpClient: HttpClient,public commonService : CommonEventService,public _DomSanitizationService: DomSanitizer,private sanitizer: DomSanitizer) { 
    this.apiMainObj.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer '+ this.apiMainObj.authorization
      })
    }
    this.apiMainObj.designPackageName="test";

   }
   getNumbersFromString(input: string): string {
    return input.replace(/\D/g, ''); // Removes non-digits
  }
   to_Num(x:any){
    return( parseInt(x,10) );
  }
  to_Float(x:any){
    if ( x!=null && x!="" && x!=undefined)
    return( parseFloat(x) );
    else
    return( parseFloat("0.00") );
  }
  public sendGetRequest(fileData:any): Observable<any>{
    // let params = new HttpParams().set("service", "fileUpload");
    return this.httpClient.post(Configuration.REST_API_SERVER+'validateEnhancedV2', fileData);
  }

  userSignInorSignUp(loginData:any){
    var headers = new  HttpHeaders().set("Authorization", "Bearer "+ "a38bf456-4a7d-4517-849d-315eb43181fb")
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userId,wqnumber:this.commonService.commonMainObj.wqId == undefined || this.commonService.commonMainObj.wqId == '' ? null : this.commonService.commonMainObj.wqId}
    return this.httpClient.post(Configuration.backendStagingServer +'/syncGuestToMid', loginData, {headers: headers,  params: params});
  }
  forgotPassword(Email:any){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                  .set("Accept", "application/json");
                                  //.set("Authorization", "Basic "+ '25dd7580-5730-11ec-8e37-277e7e5c42ef');
    // var dataObj = {
    //   Email
    // };
    return new Promise((resolve,reject)=>{ 
    this.httpClient.post<any>( Configuration.backendStagingServer + "/recover/password",Email,{headers: headers}).subscribe(data => {
      return resolve(data);
    },error=>{
      return resolve(error);
    });
    });
  }
  updatePassword(pwd:any){
    this.commonService.loadingShow();
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                                  .set("Accept", "application/json");
                                  //.set("Authorization", "Bearer "+ this.loginAccessToken);
    var dataObj = {
      userID:this.commonService.commonMainObj.userId, 
      password:pwd
    };
    return new Promise((resolve,reject)=>{ 
    this.httpClient.put<any>(Configuration.backendStagingServer+"/updatepassword",dataObj,{headers: headers}).subscribe(data => {
      this.commonService.loadingHide();
      return resolve(data);
    },error=>{
      this.commonService.loadingHide();
      return resolve(error);
    });
    });
  }
  verifyCode(verifyObj:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userId}
    return this.httpClient.post(Configuration.backendStagingServer +'/verifyOtp', verifyObj, {headers: headers, params: params});
  }
  resendCode(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userId,isOtpForLogin:'true'}
    return this.httpClient.get(Configuration.backendStagingServer +'/generateOrResendOtp', {headers: headers, params: params});
  }

  getGuestEmailInfo(guestEmailId:any){
    var headers = new HttpHeaders().set("Content-Type","application/json")
                      .set("Accept","application/json");
    var params = {emailID:guestEmailId}
    return this.httpClient.get(Configuration.Guest_Email_Url,{headers: headers, params:params});
  }

  getListOfQuotes(userId:any,memberId:any,partNumber:any,revision:any,productType:any){
    var headers = new HttpHeaders().set("Content-Type","application/json")
                      .set("Accept","application/json");
    var params = {userID:userId,memberId:memberId,partNumber:partNumber,revision:revision,productType:productType}
    return this.httpClient.get(Configuration.Pcb_Quote_Url + 'getSpxThroughMId',{headers: headers, params:params});
  }

  getPcbQuote(boardDataObj:any){
    var headers = new HttpHeaders().set("Content-Type","application/json")
                      .set("Accept","application/json");
    var params = {userID:this.commonService.commonMainObj.userId, memberId:this.commonService.commonMainObj.userSessionMemberId?this.commonService.commonMainObj.userSessionMemberId:null};
    var paramsGuest = {userID:this.commonService.commonMainObj.userId};
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"createpcbquote",boardDataObj,{headers: headers, params:params})
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"createpcbquote",boardDataObj,{headers: headers, params:paramsGuest})
    }
  }

  createPartData(partNumber:any,partRevision:any,designPackageName:any){
    var headers = new HttpHeaders().set("Content-Type","application/json")
                      .set("Accept","application/json");
    if(this.commonService.commonMainObj.userData.userId == null || this.commonService.commonMainObj.userData.userId == ""){
      this.commonService.commonMainObj.userData.userId=null; 
    }              
    var params = {userID:this.commonService.commonMainObj.userData.userId,partNumber:partNumber,partRevision:partRevision,designPackageName:designPackageName} ;
    this.apiMainObj.fileUploadedData.boardParam = this.apiMainObj.fileUploadedData.boardParam == "" ?null: this.apiMainObj.fileUploadedData.boardParam;
    this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_part_number = this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_part_number && (this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_part_number).length > 40 ? this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_part_number.slice(0, 40) : this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_part_number;
    this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_revision = this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_revision && (this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_revision).length > 10 ? this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_revision.slice(0, 10) : this.apiMainObj.fileUploadedData.boardParam_assembly.assembly_revision;
    return this.httpClient.post(Configuration.Pcb_Quote_Url+"createpcbpartdata",this.apiMainObj.fileUploadedData,{headers: headers, params:params})
  }

  assemblyBomSheetsProcees(bomFile:any){
    const formData = new FormData();
    const file = bomFile;
    formData.append('file', bomFile);
    // console.log('formData: ', formData.getAll('loginOrRegister'));
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.MAIN_URL +'/automap/sheets?memberId='+this.commonService.commonMainObj.userSessionMemberId+'&emailId='+this.commonService.commonMainObj.email,formData);
    }else{
      return this.httpClient.post(Configuration.MAIN_URL +'/automap/sheets?emailId='+this.commonService.commonMainObj.email,formData);
    }
  }

  assemblyBomProcees(bomFile:any,sheetNum:any){
    const formData = new FormData();
    const file = bomFile;
    formData.append('file', bomFile);
    // console.log('formData: ', formData.getAll('loginOrRegister'));
    return this.httpClient.post(Configuration.MAIN_URL +'/automap?sheetNumber='+sheetNum, formData);
  }

  // ADDRESS RELATED START
  getCountryList(){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                                    .set("Accept", "application/json" );
    this.httpClient.get<any>( Configuration.AppLocationBaseURL+"/country", {headers: headers}).subscribe(data =>{
      this.apiMainObj.countryList = data;
      this.apiMainObj.defaultCountry = this.apiMainObj.countryList[216];
      // console.log("default country>>", this.apiMainObj.defaultCountry);
    },error=>{
      console.log(error);
    });
  }
  getStateByCountry(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("country", "United States");
    this.httpClient.get<any>( Configuration.AppLocationBaseURL+"/state", {headers: headers, params: params}).subscribe(data =>{
      this.apiMainObj.stateList = data;
      this.apiMainObj.state_name = Object.keys(data);
      this.apiMainObj.state_code = Object.values(data);
      this.apiMainObj.defaultState = 'California';
      // console.log("STATELISTDATA",data.Alabama);
      // console.log("default state>>",this.apiMainObj.defaultState);
    },error=>{
      console.log(error);
    });
  }
  getCityByState(){
    var headers = new HttpHeaders().set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("state", "California");
    this.httpClient.get<any>( Configuration.AppLocationBaseURL+"/city", {headers: headers, params: params}).subscribe(data =>{
      this.apiMainObj.cityList = data;
      this.apiMainObj.defaultCity = this.apiMainObj.cityList[989]
      // console.log("default city>>", this.apiMainObj.defaultCity);
    },error=>{
      console.log(error);
    });
  }

  addNewAddressNew(addressId:any,address_data_body:any){
    var headersObj = new HttpHeaders().set("Content-Type", "application/json")
                                   .set("Accept", "application/json")
                                   //.set("Authorization", "Bearer "+ this.new_accessToken)
                                  //  .set("Cookie","JSESSIONID=95F3BE0B1A2CFCFE1DF5BFF1B549C03E");
    var paramsObj = {userID:this.commonService.commonMainObj.userId,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null}                               
    //let params = new HttpParams().set("userID", this.kicad_uid);
               
    var options = { headers: headersObj , params: paramsObj};
    return new Promise((resolve,reject)=>{
      this.httpClient.post<any>( Configuration.ADDRESS_REQUEST_URL + "/createaddress", address_data_body, options).subscribe((data)=>{
        resolve(data);
        // console.log(data);
      },error=>{
        resolve(error);
        console.log(error);
      })
    })
  }
  getAllAddress(addressview:any){
    var address_type = ''
    this.apiMainObj.alladdress = [];
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userId}
    //let params = new HttpParams().set("userID", "00c82b43-6fb5-4e2f-9488-0d8c1c107a98");  
    return new Promise((resolve,reject)=>{
    this.httpClient.get<any>( Configuration.ADDRESS_REQUEST_URL+"/getuseraddress", {headers: headers, params: params}).subscribe(data => {
      for(var i=0 ; i < data.length; i++){
        if(data[i].address1 == 'Your Address' || (data[i].address1 == "" && data[i].city == "" &&data[i].country == "" && data[i].state == "" && data[i].zip == "") || (data[i].firstname == "Assembly" && data[i].lastname == "Receiving")){
          data.splice(i,1);
          // break;
          // delete data[i]
        }
      }
        var addressListArray = new Array();
        var first = new Array();
        var addresses = data;
        for(var i=0 ; i < addresses.length; i++){
          // if(address_type == addresses[i].addressType){
            // if(addresses[i].address1 != 'Your Address' && (addresses[i].country != 'Your Country' && addresses[i].state != 'Your State' && addresses[i].city != 'Your City')){
              addresses[i].phone = this.getNumbersFromString(addresses[i].phone);
              if (i==0 && addressview == 'list') {
                this.apiMainObj.selectedBillingAddress = {};
                this.apiMainObj.selectedShippingAddress = {};
                this.apiMainObj.selectedDesignerAddress = {};
              }
              addressListArray.push({
                firstName           :addresses[i].firstname,
                lastName            :addresses[i].lastname,
                addressLine1        :addresses[i].address1,
                addressLine2        :addresses[i].address2,
                city                :addresses[i].city,
                state               :addresses[i].state,
                country             :addresses[i].country,
                zip                 :addresses[i].zip,
                phoneNumber         :addresses[i].phone,
                fax                 :addresses[i].fax,
                default             :addresses[i].defaultForType,
                //scaUserId         :addresses[i].scaUserId,
                addressId           :addresses[i].addressid,
                // addressTypeId       :addresses[i].addressType,
                email               :addresses[i].email,
                companyName         :addresses[i].company,
                isDefaultForBilling :addresses[i].isDefaultForBilling,
                isDefaultForDesign  :addresses[i].isDefaultForDesign,
                isDefaultForShipping:addresses[i].isDefaultForShipping
              })
            // }
            if (addressview == 'list') {
              if (addresses[i].isDefaultForShipping == '1' || addresses[i].isDefaultForShipping == 1) {
                this.apiMainObj.selectedShippingAddress = addressListArray[i];
              }
              if (addresses[i].isDefaultForDesign == '1' || addresses[i].isDefaultForDesign == 1) {
                this.apiMainObj.selectedDesignerAddress = addressListArray[i];
              }
              if (addresses[i].isDefaultForBilling == '1' || addresses[i].isDefaultForBilling == 1) {
                this.apiMainObj.selectedBillingAddress = addressListArray[i];
              }
            }
        }
        this.apiMainObj.alladdress = addressListArray;
        // console.log("Length of all addresess", this.apiMainObj.alladdress.length);
        return resolve(data);
       }, error => {
        this.commonService.loadingHide();
        return resolve(error);
        console.log(error);
      });
    })
  }
  updateNewAddressDetails(addressId:any){
    //this.address_id = addressId;
    // console.log("AD ID", addressId);
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                                    .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userId,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null} 
    //this.address_type_id
    // var default_add = this.default_add_address == true ? "1":"0";
    var update_address_body = {
      // "addressType":this.address_type_id,
    //   "addressid":this.address_id, 
      "addressid":addressId, 
      "firstname":this.apiMainObj.contact_first_name,
      "lastname":this.apiMainObj.contact_last_name, 
      "email":this.apiMainObj.contact_email, 
      "phone":this.apiMainObj.contact_phone,
    //   "fax":this.contact_fax,
      "fax":"",
      "address1": this.apiMainObj.contact_address1 , 
      "address2" : this.apiMainObj.contact_address2,
      "city":this.apiMainObj.contact_city ,
      "country":this.apiMainObj.contact_country, 
      "state":this.apiMainObj.contact_state,
      "zip":this.apiMainObj.contact_zipcode,
      // "defaultForType":default_add,
      "company":this.apiMainObj.contact_company,
      // "isDefaultForShipping": this.apiMainObj.address_type_id.join().indexOf('3')>-1? '1': '0',
      // "isDefaultForBilling": this.apiMainObj.address_type_id.join().indexOf('2')>-1? '1': '0',
      // "isDefaultForDesign": this.apiMainObj.address_type_id.join().indexOf('1')>-1? '1': '0'
      "isDefaultForShipping": this.apiMainObj.isShippingChecked == true ? '1': '0',
      "isDefaultForBilling": this.apiMainObj.isBillingChecked == true ?  '1': '0',
      "isDefaultForDesign": this.apiMainObj.isDesignerChecked == true ?  '1': '0'
    };
    // console.log("update_address_body",update_address_body); 
    return this.httpClient.put<any>( Configuration.ADDRESS_REQUEST_URL + "/updateaddress",update_address_body,{headers: headers, params:params })
  }
  deleteAddress(addressId:any){
    var addressID = addressId;
    // console.log("deleteing address id", addressId);
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                                    .set("Accept", "application/json" );
    let params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                 .set("addressId", addressID);
    return new Promise((resolve,reject)=>{
    this.httpClient.delete<any>( Configuration.ADDRESS_REQUEST_URL +"/deleteaddress", {headers: headers, params:params}).subscribe(data => {
        // console.log(data);
        return resolve(data);
    }, error => {
        return resolve(error);
        console.log(error);
    }); 
    })
  }

  
  validateAddress(){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                                    .set("Accept", "application/json" );
    var params ={userID:this.commonService.commonMainObj.userId};
    var addressDataObj = {
      "firstname":this.apiMainObj.contact_first_name,
      "lastname":this.apiMainObj.contact_last_name, 
      "email":this.apiMainObj.contact_email, 
      "phone":this.apiMainObj.contact_phone,
      "address1": this.apiMainObj.contact_address1 , 
      "address2" : this.apiMainObj.contact_address2,
      "city":this.apiMainObj.contact_city ,
      "country":this.apiMainObj.contact_country, 
      "state":this.apiMainObj.contact_state,
      "zip":this.apiMainObj.contact_zipcode,
      "company":this.apiMainObj.contact_company,
      "fax":"",
      "isDefaultForShipping": this.apiMainObj.isShippingChecked,
      "isDefaultForBilling": this.apiMainObj.isBillingChecked,
      "isDefaultForDesign": this.apiMainObj.isDesignerChecked
    }
    return this.httpClient.post<any>( Configuration.ADDRESS_REQUEST_URL + "/validateAddress",addressDataObj,{headers: headers, params:params })
  }

  validateMultipleAddress(){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                                    .set("Accept", "application/json" );
    var params ={userID:this.commonService.commonMainObj.userId};
    var addressDataObj={
      "shippingAddress": this.apiMainObj.selectedShippingAddress.country != 'United States' ? null:{
        "firstname": this.apiMainObj.selectedShippingAddress.firstName,
        "lastname": this.apiMainObj.selectedShippingAddress.lastName,
        "address1": this.apiMainObj.selectedShippingAddress.addressLine1,
        "address2": this.apiMainObj.selectedShippingAddress.addressLine2,
        "city": this.apiMainObj.selectedShippingAddress.city,
        "state": this.apiMainObj.selectedShippingAddress.state,
        "zip": this.apiMainObj.selectedShippingAddress.zip,
        "country": this.apiMainObj.selectedShippingAddress.country
      },
      "billingAddress":this.apiMainObj.selectedBillingAddress.country != 'United States' ? null:{
        "firstname": this.apiMainObj.selectedBillingAddress.firstName,
        "lastname": this.apiMainObj.selectedBillingAddress.lastName,
        "address1": this.apiMainObj.selectedBillingAddress.addressLine1,
        "address2": this.apiMainObj.selectedBillingAddress.addressLine2,
        "city": this.apiMainObj.selectedBillingAddress.city,
        "state": this.apiMainObj.selectedBillingAddress.state,
        "zip": this.apiMainObj.selectedBillingAddress.zip,
        "country": this.apiMainObj.selectedBillingAddress.country
      },
      "designerAddress": this.apiMainObj.selectedDesignerAddress.country != 'United States' ? null:{
        "firstname": this.apiMainObj.selectedDesignerAddress.firstName,
        "lastname": this.apiMainObj.selectedDesignerAddress.lastName,
        "address1": this.apiMainObj.selectedDesignerAddress.addressLine1,
        "address2": this.apiMainObj.selectedDesignerAddress.addressLine2,
        "city": this.apiMainObj.selectedDesignerAddress.city,
        "state": this.apiMainObj.selectedDesignerAddress.state,
        "zip": this.apiMainObj.selectedDesignerAddress.zip,
        "country": this.apiMainObj.selectedDesignerAddress.country
      },
      "shippingDetails":{
        "shippingAccountNumber" : this.commonService.commonMainObj.shippingAccountNumber ? this.commonService.commonMainObj.shippingAccountNumber:'',
        "shippingTypeId": this.commonService.commonMainObj.shippingMethod ? parseInt(this.commonService.commonMainObj.shippingMethod):'',
        "shippingTypeName": this.commonService.commonMainObj.selectedShippingMethodOption ? this.commonService.commonMainObj.selectedShippingMethodOption:'',
      }
    }
    return this.httpClient.post<any>( Configuration.ADDRESS_REQUEST_URL + "/preValidateOrder",addressDataObj,{headers: headers, params:params })
  }
  // ADDRESS RELATED END

  //Tax RELATED START
  getTaxData(): Observable<any>{
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    var params = {memberId:this.commonService.commonMainObj.userSessionMemberId?this.commonService.commonMainObj.userSessionMemberId:null}                  
    return this.httpClient.get<any>(Configuration.ADDRESS_REQUEST_URL + "/gettaxdetails", {headers:headers,params:params})
  }
  //Tax RELATED END
  //Get Order summery details
  orderSummary(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                 .set("wqID", this.commonService.commonMainObj.wqId);
    this.httpClient.get<any>(Configuration.Pcb_Quote_Url + "finalQuoteDetails", {headers:headers, params:params}).subscribe(data =>{
        // console.log("finalQuoteDetails",data);
        this.commonService.commonMainObj.orderSummery = data.quoteItems;
        for(var i=0; i < this.commonService.commonMainObj.orderSummery.length ; i++){
          if(this.commonService.commonMainObj.orderSummery[i].quoteItemType == "PCB"){
            this.commonService.commonMainObj.OrdSumNumOfPcbs = this.commonService.commonMainObj.orderSummery[i].quantity;
            this.commonService.commonMainObj.OrdSumPcbTurnTime = this.commonService.commonMainObj.orderSummery[i].turntime;
            // Commented for OFP-1931 
            // this.commonService.commonMainObj.OrdSumPcbCharges = this.commonService.commonMainObj.orderSummery[i].boardPrice;
            this.commonService.commonMainObj.OrdSumPcbCharges = this.commonService.commonMainObj.orderSummery[i].subTotal;
            this.commonService.commonMainObj.ordSumEtestCharge = this.commonService.commonMainObj.orderSummery[i].electricalTestingPrice;
            this.commonService.commonMainObj.ordSumPcbSubTotal = this.commonService.commonMainObj.orderSummery[i].subTotal;
          }else if(this.commonService.commonMainObj.orderSummery[i].quoteItemType == "ASSEMBLY"){
            this.commonService.commonMainObj.OrdSumNumOfAssembly = this.commonService.commonMainObj.orderSummery[i].quantity;
            this.commonService.commonMainObj.OrdSumAssemblyTurnTime = this.commonService.commonMainObj.orderSummery[i].turntime;
            // Commented for OFP-1931
            // this.commonService.commonMainObj.OrdSumAssemblyCharges = this.commonService.commonMainObj.orderSummery[i].boardPrice;
            this.commonService.commonMainObj.OrdSumAssemblyCharges = this.commonService.commonMainObj.orderSummery[i].subTotal;
          }else if(this.commonService.commonMainObj.orderSummery[i].quoteItemType == "COMPONENTS"){
            // Commented for OFP-1931
            // this.commonService.commonMainObj.OrdSumComponentCharges = this.commonService.commonMainObj.orderSummery[i].boardPrice;
            this.commonService.commonMainObj.OrdSumComponentCharges = this.commonService.commonMainObj.orderSummery[i].subTotal;
          }
          this.commonService.commonMainObj.assemblyComponentTotal = this.to_Float(this.commonService.commonMainObj.OrdSumAssemblyCharges) + this.to_Float(this.commonService.commonMainObj.OrdSumComponentCharges);
        }
    }, error =>{
        console.log('error found while get orderSummary', error);
        //this.presentAlert()
    });
  }
  //Get Order summery detailsEND
  //shippingMethod Start
  getShippingOptions(loadType:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      //.set("Authorization", "Bearer "+ this.new_accessToken);

    let params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                .set("country", this.apiMainObj.selectedShippingAddress.country)
                                .set("state", this.apiMainObj.selectedShippingAddress.state)
                                .set("shippingZip", this.apiMainObj.selectedShippingAddress.zip)
                                .set("wqnumber", this.commonService.commonMainObj.wqId);
    return new Promise((resolve,reject)=>{
    //if (this.commonService.commonMainObj.wqId && this.selectedShippingAddress.country) {
        this.httpClient.get<any>(Configuration.ADDRESS_REQUEST_URL + "/getShippingoptions", {headers: headers, params: params}).subscribe(data => {
          // console.log(data);
          var shippingOptionArray = new Array();
          var shipping        = data.shippingItems;
          if (shipping) {
            for(var i = 0; i < shipping.length; i++){
              shippingOptionArray.push({
                  shippingID      : shipping[i].shippingID,
                  shippingOption  : shipping[i].shippingOption,
                  shippingPrice   : shipping[i].shippingPrice
                })
            }
          }
          // this.shippingOptionResponse = shippingOptionArray;
          return resolve(shippingOptionArray);
          }, error => {
          return resolve(error);
          console.log(error);
        }) 
    // }else{
    //   return resolve([]);
    // }
    });

  }
  //shippingMethod End
  createPcbFinalQuote(finalQuoteObj:any): Observable<any>{
    var headers = new HttpHeaders().set("Content-Type","application/json")
                      .set("Accept","application/json");
    var params = {userID:this.commonService.commonMainObj.userId,wmqID:this.commonService.commonMainObj.wmqId,email:this.commonService.commonMainObj.email,memberId:this.commonService.commonMainObj.userSessionMemberId?this.commonService.commonMainObj.userSessionMemberId:null} ;
    var paramsGuest = {userID:this.commonService.commonMainObj.userId,wmqID:this.commonService.commonMainObj.wmqId,email:this.commonService.commonMainObj.email,memberId:'null'} ;
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"createpcbfinalquote",finalQuoteObj,{headers: headers, params:params})
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"createpcbfinalquote",finalQuoteObj,{headers: headers, params:paramsGuest})
    }
  }

  createAssemblyFabFinalQuote(finalQuoteObj:any): Observable<any>{
    var headers = new HttpHeaders().set("Content-Type","application/json")
                      .set("Accept","application/json");
    var params = {userID:this.commonService.commonMainObj.userId,wmqID:this.commonService.commonMainObj.wmqId,email:this.commonService.commonMainObj.email,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null} ;
    var paramsGuest = {userID:this.commonService.commonMainObj.userId,wmqID:this.commonService.commonMainObj.wmqId,email:this.commonService.commonMainObj.email} ;
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"finalassemblyquote",finalQuoteObj,{headers: headers, params:params})  
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"finalassemblyquote",finalQuoteObj,{headers: headers, params:paramsGuest})  
    }  
  }

  updateFinalQuoteApi(){
    var headers = new HttpHeaders().set("Content-Type","appplication/json")
                                    .set("Accept","application/json");
    // let params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
    //                               .set("wmqId", this.commonService.commonMainObj.wmqId)
    //                               .set("webQuoteId", this.commonService.commonMainObj.wqId);
    // var params = {userID:this.commonService.commonMainObj.userId, wmqId:this.commonService.commonMainObj.wmqId, webQuoteId:this.commonService.commonMainObj.wqId};
    return this.httpClient.put(Configuration.Pcb_Quote_Url+"pcbFinalQuote?userID="+this.commonService.commonMainObj.userId+"&wmqId="+this.commonService.commonMainObj.wmqId+"&webQuoteId="+this.commonService.commonMainObj.wqId,{});
    // return this.httpClient.put(this.Pcb_Quote_Url+"pcbFinalQuote",{headers:headers,params:params});
  }

  getUserDataSession(sessionEncData:any): Observable<any>{
    return this.httpClient.get(Configuration.backendStagingServer + "/userSessionDetails?encryptKey=data="+sessionEncData, {});
  }

  
  //get Notification list
  getNotificationData(){
    var headers = new  HttpHeaders()
    // .set("Authorization", "bearer "+this.FEMS_accessToken.access_token)
      .set("Content-Type", "application/json" )
      .set("Accept", "application/json" );
    
    var params = {userID:this.commonService.commonMainObj.userId, ordernumber:this.commonService.commonMainObj.orderPlacedData.orderNumber}
    this.httpClient.get<any>(Configuration.Order_Url + "/getnotifications", {headers:headers, params:params}
        ).subscribe(data =>{
          this.commonService.commonMainObj.primaryCheckCount['trueCount'] = 0;
          // console.log("get Notification data");
          // console.log(data);  

          var NotificationListArray = new Array();
          var notification        = data;
          for(var i = 0; i < notification.length; i++){
            if(notification[i].roles.primary == "1"){
              this.commonService.commonMainObj.primaryCheckCount['trueCount'] += 1;
            }
            //Toget only numbers without any special charectore
            notification[i].phone=this.getNumbersFromString(notification[i].phone);
            
            NotificationListArray.push({
              firstNmae    : notification[i].firstNmae,
              lastName     : notification[i].lastName,
              email        : notification[i].email,
              phone        : notification[i].phone,
              dnd          : notification[i].dnd == "1" ? true:false,
              primary      : notification[i].roles.primary == "1" ? true:false,
              designer     : notification[i].roles.designer == "1" ? true:false,
              billing      : notification[i].roles.billing == "1" ? true:false,
              shipping     : notification[i].roles.shipping == "1" ? true:false,
              engineer     : notification[i].roles.engineer == "1" ? true:false,
              qualityCtrl  : notification[i].roles.qualityCtrl == "1" ? true:false,
              twentyFourHrs: notification[i].roles.twentyFourHrs == "1" ? true:false,
              shareProject : notification[i].roles.shareProject == "1" ? true:false,
              })
          }
          this.commonService.commonMainObj.notificationData = NotificationListArray;
          // console.log("Re-arranged Notification Data", this.commonService.commonMainObj.notificationData);
        }, error =>{
          console.log('error found while get Notifiction data', error);
        });
  }
  
  //Update Notification list
  updateNotificationDetails(){
    var headers = new HttpHeaders()
    // .set("Authorization" , "bearer "+this.FEMS_accessToken.access_token)
                                  .set("Content-Type", "application/json" )
                                  .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userId, orderId:this.commonService.commonMainObj.orderPlacedData.orderNumber,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null}
    
    let notificationList=[];
    for(var k=0;k<this.commonService.commonMainObj.notificationData.length;k++){
      notificationList.push({
          "firstNmae": this.commonService.commonMainObj.notificationData[k].firstNmae,
          "lastName": this.commonService.commonMainObj.notificationData[k].lastName,
          "email": this.commonService.commonMainObj.notificationData[k].email,
          "phone": this.commonService.commonMainObj.notificationData[k].phone,
          "dnd": this.commonService.commonMainObj.notificationData[k].dnd == false ? "0" : "1",
        "roles": {
          "primary": this.commonService.commonMainObj.notificationData[k].primary == false ? "0" : "1",
          "designer": this.commonService.commonMainObj.notificationData[k].designer == false ? "0" : "1",
          "billing": this.commonService.commonMainObj.notificationData[k].billing == false ? "0" : "1",
          "shipping": this.commonService.commonMainObj.notificationData[k].shipping == false ? "0" : "1",
          "engineer": this.commonService.commonMainObj.notificationData[k].engineer == false ? "0" : "1",
          "qualityCtrl": this.commonService.commonMainObj.notificationData[k].qualityCtrl == false ? "0" : "1",
          "twentyFourHrs": this.commonService.commonMainObj.notificationData[k].twentyFourHrs == false ? "0" : "1",
          "shareProject": this.commonService.commonMainObj.notificationData[k].shareProject == false ? "0" : "1"
        }
      });
    }
    
    var update_notification_body ={notificationList:notificationList}
    //console.log(update_notification_body);
    return new Promise((resolve,reject)=>{
      return this.httpClient.put<any>( Configuration.Order_Url + "/updatenotifications"
      ,update_notification_body
      ,{headers: headers, params:params}
      ).subscribe(data => {
        var updateNotificationList = data;
        //console.log("nnnnnnn", data);
        this.commonService.alertCall('',"Notification details updated");
        // console.log("updatedNotificationData", updateNotificationList);
        return resolve(data);
      },error=>{
        console.log(error);
        var errstr = "";
        for(var err in error.error.fieldErrors[0]){
          errstr += err.split(".")[1]+" : "+error.error.fieldErrors[0][err]+'<br>';
        }
        this.commonService.notificationAlert('Error!', errstr);
        return resolve(error);
      });
    })
    

  }

  public createPcbCustomQuote(fileData:any): Observable<any>{
    // let params = new HttpParams().set("service", "fileUpload");
    var params = {userID:this.commonService.commonMainObj.userId,memberId:this.commonService.commonMainObj.userSessionMemberId?this.commonService.commonMainObj.userSessionMemberId:null};
    var paramsGuest = {userID:this.commonService.commonMainObj.userId,};
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"pcbCustomQuote", fileData,{params:params});
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"pcbCustomQuote", fileData,{params:paramsGuest});
    }
  }

  public placeOrder(fileData:any): Observable<any>{
    // s3FileId:(this.commonService.commonMainObj.s3FileName.split('.').slice(0, -1).join('.')),fileName: this.commonService.commonMainObj.uploadedFileName,
    var params = {userID:this.commonService.commonMainObj.userId,wqnumber:this.commonService.commonMainObj.wqId,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null};
    return this.httpClient.post(Configuration.Order_Url+"/placeOrderV2", fileData,{params:params});
  }

  saveEditOrFixLineItemReq(lineItemData:any): Observable<any>{
    var headers = new HttpHeaders().set("Authorization", "oneflow")
    .set("Content-Type", "application/json; charset=utf-8" )
    .set("queueUrl", '' )
    .set("internalQueueUrl", '' );

    // return new Promise((resolve,reject)=>{  
    //   return this.httpClient.put<any>( this.AppLocationBaseURL + "/bom/"+lineItemData.bom_id+'/item/'+lineItemData.bom_item_id,lineItemData,{headers: headers}
    //         ).subscribe(data => {
    //           console.log('res')
    //         },error=>{
    //           console.log(error);
    //     });
    //   });
    lineItemData['internalQueueUrl'] = ''
    lineItemData['queueUrl'] = ''
    // return this.httpClient.put<any>( this.AppLocationBaseURL + "/bom/"+lineItemData.bom_id+'/item/'+lineItemData.bom_item_id,lineItemData,{headers: headers});  
    return this.httpClient.put<any>( Configuration.scaBomUrl + "/bom/"+lineItemData.bom_id+'/item/'+lineItemData.bom_item_id,lineItemData,{headers: headers});  
  }

  saveEditDni(multiData:any,bomId:any): Observable<any>{
    var headers = new HttpHeaders().set("Authorization", "Bearer ").set("Content-Type", "application/json" );
    // var lineItemData ={};
    // lineItemData['internalQueueUrl'] = ''
    // lineItemData['queueUrl'] = ''
    return this.httpClient.put<any>( Configuration.scaBomUrl + "/bom/items/donotinstall/"+multiData,'',{headers: headers});  
    // return this.httpClient.put<any>( this.AppLocationBaseURL + "/bom/"+bomId+'/item/'+multiData,lineItemData,{headers: headers});  
  }
  deleteLineItemData(bomId:any,bomLineItemId:any): Observable<any>{
    var headers = new HttpHeaders()
    .set("Authorization", "oneflow ")
    .set("Content-Type", "application/json" )
    // .set("queueUrl", '' ).set("internalQueueUrl", '' );
      return this.httpClient.delete<any>( Configuration.scaBomUrl + "/bom/"+bomId+'/item/'+bomLineItemId,{headers: headers});
      // return this.httpClient.delete<any>( this.AppLocationBaseURL + "/bom/"+bomId+'/item/'+bomLineItemId,{headers: headers});
  }

  getBOMTable(bomId:any): Observable<any>{
    var headers = new HttpHeaders()
    .set("Authorization", "Bearer ")
    .set("Content-Type", "application/json" )
    .set("queueUrl", '' )
    .set("internalQueueUrl", '' );
    
    return this.httpClient.get<any>( Configuration.scaBomUrl+"/bom/"+bomId, {headers: headers})
    // return this.httpClient.get<any>( this.AppLocationBaseURL+"/bom/"+bomId, {headers: headers})
  }

  bomQuoteData(bomFData:any): Observable<any>{
    var headers = new  HttpHeaders()
                      // .set("Authorization", "")
                      .set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    var params = {userId:this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null,wmqId:this.commonService.commonMainObj.wmqId,quantity:this.commonService.commonMainObj.qtyAssemblies,sidesForAssembly:this.commonService.commonMainObj.assemblySides,llProcessing:this.commonService.commonMainObj.leadFreeProcessing,emailId:this.commonService.commonMainObj.userData.userId?null:this.commonService.commonMainObj.email,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null}
    var paramsGuest = {userId:this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null,wmqId:this.commonService.commonMainObj.wmqId,quantity:this.commonService.commonMainObj.qtyAssemblies,sidesForAssembly:this.commonService.commonMainObj.assemblySides,llProcessing:this.commonService.commonMainObj.leadFreeProcessing,emailId:this.commonService.commonMainObj.userData.userId?null:this.commonService.commonMainObj.email}
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"bomquote", bomFData,{headers:headers,params:params});
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"bomquote", bomFData,{headers:headers,params:paramsGuest});
    }
  }


  bomAssemblyQuoteData(): Observable<any>{
    var qtyOfAssembly = {
      "quantity": this.commonService.commonMainObj.qtyAssemblies
    }
    var headers = new  HttpHeaders()
                      // .set("Authorization", "")
                      .set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    var params = {userID:this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null,wmqID:this.commonService.commonMainObj.wmqId,quantity:this.commonService.commonMainObj.qtyAssemblies,sidesForAssembly:this.commonService.commonMainObj.assemblySides,llProcessing:this.commonService.commonMainObj.leadFreeProcessing,emailId:this.commonService.commonMainObj.userData.userId?null:this.commonService.commonMainObj.email,thruHoleViainPad:this.commonService.commonMainObj.viaInPadData,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null};
    var paramsGuest = {userID:this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null,wmqID:this.commonService.commonMainObj.wmqId,quantity:this.commonService.commonMainObj.qtyAssemblies,sidesForAssembly:this.commonService.commonMainObj.assemblySides,llProcessing:this.commonService.commonMainObj.leadFreeProcessing,emailId:this.commonService.commonMainObj.userData.userId?null:this.commonService.commonMainObj.email,thruHoleViainPad:this.commonService.commonMainObj.viaInPadData};
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"assemblyquote", qtyOfAssembly,{headers:headers,params:params});
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"assemblyquote", qtyOfAssembly,{headers:headers,params:paramsGuest});
    }
  }

  getBOMData(bomMapData:any): Observable<any>{
    var headers = new HttpHeaders().set("Content-Type","application/json")
    .set("Accept","application/json");
    var params = {memberId:this.commonService.commonMainObj.userSessionMemberId?this.commonService.commonMainObj.userSessionMemberId:null};
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post(Configuration.scaBomUrl+"/bom/oneflow", bomMapData,{headers: headers, params:params});
    }else{
      return this.httpClient.post(Configuration.scaBomUrl+"/bom/oneflow", bomMapData,{headers: headers});
    }
    
  }

  gotoOrder(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                 .set("orderNumber", this.commonService.commonMainObj.orderPlacedData.orderNumber);
    this.httpClient.get<any>(Configuration.Order_Url+"/redirectUrl", {headers:headers, params:params}).subscribe(data =>{
      // console.log("URL REDIRECT",data);
    var responseData = data;
      this.commonService.commonMainObj.orderRedirectUrl = responseData.redirectUrl;
      //window.open(responseData.redirectUrl, '_blank');
    }, error =>{
        console.log('Error in tracking your order', error);
        //this.presentAlert()
    });
  }

  getAutoUploadBOMFile(fileDataUrl:any,imgType:any): Observable<any> {
    let params = new HttpParams().set("service", "getFile")
                                  .set("fileName", fileDataUrl);
    return this.httpClient.get<any>(Configuration.REST_API_SERVER + "superAPI"
      ,{ params:params, responseType: 'blob' as 'json', observe: 'response' as 'body' }
      )
  }

  getImageFile(imgFileName:any,imgType:any){
    let params = new HttpParams().set("service", "getFile")
                                  .set("fileName", imgFileName);
    this.httpClient.get<any>(Configuration.REST_API_SERVER + "superAPI"
      ,{ params:params }
      ).subscribe(async (data: any)=>{
        // console.log("img data",data);
        var dataSlice = data['body'].slice(2,-1);
        if(imgType == "bottom"){
          this.commonService.commonMainObj.bottomImagePath = 'data:image/jpg;base64,' + (this._DomSanitizationService.bypassSecurityTrustResourceUrl(dataSlice) as any).changingThisBreaksApplicationSecurity;
        }else if(imgType == "top"){
          this.commonService.commonMainObj.topImagePath = 'data:image/jpg;base64,' + (this._DomSanitizationService.bypassSecurityTrustResourceUrl(dataSlice) as any).changingThisBreaksApplicationSecurity;
          // console.log("this.commonService.commonMainObj.topImagePath",this.commonService.commonMainObj.topImagePath);
        }else{
          console.log(dataSlice);
        }
      }, (error: any)=>{
        if(imgType == "bottom"){
          this.commonService.commonMainObj.bottomImagePath = error.url;
        }
        if(imgType == "top"){
          this.commonService.commonMainObj.topImagePath = error.url;
        }
      });
  }
  promoDeatils(promocode:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("promoCode", promocode)
                                  .set("shippingMethod", this.commonService.commonMainObj.shippingMethod)
                                  .set("shippingCountry", this.apiMainObj.selectedShippingAddress?this.apiMainObj.selectedShippingAddress.country:'')
                                  .set("shippingState", this.apiMainObj.selectedShippingAddress?this.apiMainObj.selectedShippingAddress.state:'')
                                  .set("zipCode", this.apiMainObj.selectedShippingAddress?this.apiMainObj.selectedShippingAddress.zip:'')
                                  .set("webQuoteNumber", this.commonService.commonMainObj.wqId);
    return this.httpClient.get<any>( Configuration.QA_ORDER_URL+"getpromocodedetails",{headers: headers, params:params })
  }
  fileDataWithId(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("id", this.commonService.commonMainObj.fileId);
    return this.httpClient.get<any>( Configuration.REST_API_SERVER+"getRequestData",{headers: headers, params:params })
  }
  public reValidateMissingFiles(fileData:any): Observable<any>{
    // let params = new HttpParams().set("service", "fileUpload");
    return this.httpClient.post(Configuration.REST_API_SERVER+'attachFiles', fileData);
  }

  updateActionData(bomMapData:any,actionType:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("componentId", bomMapData.componentId)
                                  .set("bomId", this.commonService.commonMainObj.finalBomDataToPurchase.bomId)
                                  .set("selectedAction", bomMapData.selectedAction)
                                  .set("emailId", this.commonService.commonMainObj.email)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  // .set("actionBy", 0);
    let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                      .set("componentId", bomMapData.componentId)
                                      .set("bomId", this.commonService.commonMainObj.finalBomDataToPurchase.bomId)
                                      .set("selectedAction", bomMapData.selectedAction)
                                      .set("emailId", this.commonService.commonMainObj.email) 
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+'updateSelectedAction',bomMapData,{headers: headers, params:params });
    }else{
      return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+'updateSelectedAction',bomMapData,{headers: headers, params:paramsGuest });
    }                         
    
  }

  getResolveIssue(compId:any,bom_compId:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("bomId", bom_compId)
                                  .set("componentId", compId)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("emailId", this.commonService.commonMainObj.email);
    let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                      .set("bomId", bom_compId)
                                      .set("componentId", compId)
                                      .set("emailId", this.commonService.commonMainObj.email);
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"getResolveIssueForMPN",{headers: headers, params:params })
    }else{
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"getResolveIssueForMPN",{headers: headers, params:paramsGuest })
    }
    
  }

  getCustomerInteraction(bomCompId:any,bom_compId:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("bomId", bom_compId)
                                  .set("bomComponentId", bomCompId)
                                  .set("emailId", this.commonService.commonMainObj.email);
    let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                      .set("bomId", bom_compId)
                                      .set("bomComponentId", bomCompId)
                                      .set("emailId", this.commonService.commonMainObj.email);
    if(!this.commonService.commonMainObj.isGuestUser){                                 
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"getCustomerInteractions",{headers: headers, params:params })
    }else{
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"getCustomerInteractions",{headers: headers, params:paramsGuest })
    }
  }

  submitInteraction(bomCompId:any,bom_compId:any,msg:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("bomId", bom_compId)
                                  .set("bomComponentId", bomCompId)
                                  .set('message',msg)
                                  .set("emailId", this.commonService.commonMainObj.email);
    let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                      .set("bomId", bom_compId)
                                      .set("bomComponentId", bomCompId)
                                      .set('message',msg)
                                      .set("emailId", this.commonService.commonMainObj.email);
    if(!this.commonService.commonMainObj.isGuestUser){                                  
      return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+"getCustomerInteractionsWithNewPost",{},{headers: headers, params:params })
    }else{
      return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+"getCustomerInteractionsWithNewPost",{},{headers: headers, params:paramsGuest }) 
    }
  }

  submitResolutionOption(compId:any,bom_id:any,resolId:any,mpnData:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    if(mpnData && resolId != 10){
      let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                    .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                    .set("bomId", bom_id)
                                    .set("componentId", compId)
                                    .set('resolutionId',resolId)
                                    .set('mpn',mpnData.mpn)
                                    .set('qty',mpnData.qty)
                                    .set('ref_desc',mpnData.ref_designators?mpnData.ref_designators:mpnData.refdesc)
                                    .set("emailId", this.commonService.commonMainObj.email);
        let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                          .set("bomId", bom_id)
                                          .set("componentId", compId)
                                          .set('resolutionId',resolId)
                                          .set('mpn',mpnData.mpn)
                                          .set('qty',mpnData.qty)
                                          .set('ref_desc',mpnData.ref_designators?mpnData.ref_designators:mpnData.refdesc)
                                          .set("emailId", this.commonService.commonMainObj.email);
        if(!this.commonService.commonMainObj.isGuestUser){
          return this.httpClient.put<any>( Configuration.Pcb_Quote_Url+"performResolveMPNActions",{},{headers: headers, params:params })
        }else{
          return this.httpClient.put<any>( Configuration.Pcb_Quote_Url+"performResolveMPNActions",{},{headers: headers, params:paramsGuest })
        }
    }else if(resolId == 10){
        let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                      .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                      .set("bomId", bom_id)
                                      .set("componentId", compId)
                                      .set('resolutionId',resolId)
                                      .set('mpn',mpnData.mpn)
                                      .set("emailId", this.commonService.commonMainObj.email);
        let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                        .set("bomId", bom_id)
                                        .set("componentId", compId)
                                        .set('resolutionId',resolId)
                                        .set('mpn',mpnData.mpn)
                                        .set("emailId", this.commonService.commonMainObj.email);
        if(!this.commonService.commonMainObj.isGuestUser){
          return this.httpClient.put<any>( Configuration.Pcb_Quote_Url+"performResolveMPNActions",{},{headers: headers, params:params })
        }else{
          return this.httpClient.put<any>( Configuration.Pcb_Quote_Url+"performResolveMPNActions",{},{headers: headers, params:paramsGuest })
        }
        
    }else{
      let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                    .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                    .set("bomId", bom_id)
                                    .set("componentId", compId)
                                    .set('resolutionId',resolId)
                                    .set("emailId", this.commonService.commonMainObj.email);
      let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                        .set("bomId", bom_id)
                                        .set("componentId", compId)
                                        .set('resolutionId',resolId)
                                        .set("emailId", this.commonService.commonMainObj.email);   
      if(!this.commonService.commonMainObj.isGuestUser){                          
        return this.httpClient.put<any>( Configuration.Pcb_Quote_Url+"performResolveMPNActions",{},{headers: headers, params:params })
      }else{
        return this.httpClient.put<any>( Configuration.Pcb_Quote_Url+"performResolveMPNActions",{},{headers: headers, params:paramsGuest })
      }
    }
  }
  
  submitMpnLevel1Check(compId:any,bom_id:any,mpnData:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("bomId", bom_id)
                                  .set("componentId", compId)
                                  .set('mpn',mpnData.mpn)
                                  .set('quantity',mpnData.qty)
                                  .set('itemNum',mpnData.itemNumber)
                                  .set('refDesignators',mpnData.refdesc)
                                  .set('isLineItemModified',this.commonService.commonMainObj.isLineItemModified);
                                  
    let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("bomId", bom_id)
                                  .set("componentId", compId)
                                  .set('mpn',mpnData.mpn)
                                  .set('quantity',mpnData.qty)
                                  .set('refDesignators',mpnData.refdesc)
                                  .set('itemNum',mpnData.itemNumber)
                                  .set("emailId", this.commonService.commonMainObj.email)
                                  .set('isLineItemModified',this.commonService.commonMainObj.isLineItemModified);
    if(!this.commonService.commonMainObj.isGuestUser){                                
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"validate-bom",{headers: headers, params:params })
    }else{
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"validate-bom",{headers: headers, params:paramsGuest })
    }
  }

  getNewProcureMentData(bomId:any){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
                      //.set("Authorization","Bearer 5f1708cc-7c5c-11ee-aa29-92a471baf889");
    let params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
                                  .set("bomId", bomId)
                                  .set("emailId", this.commonService.commonMainObj.email);
    let paramsGuest = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("bomId", bomId)
                                  .set("emailId", this.commonService.commonMainObj.email);
    if(!this.commonService.commonMainObj.isGuestUser){
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"getItemsAfterNewPost",{headers: headers, params:params })
    }else{
      return this.httpClient.get<any>( Configuration.Pcb_Quote_Url+"getItemsAfterNewPost",{headers: headers, params:paramsGuest })
    }
  }

  public saveQuoteApi(sendFormData:any): Observable<any>{
    var params = {quoteNumber:this.commonService.commonMainObj.wqId,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null,userId:this.commonService.commonMainObj.userId?this.commonService.commonMainObj.userId:null};
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    // var s3fileId = (this.commonService.commonMainObj.s3FileName.split('.').slice(0, -1).join('.'));
    // let params = new HttpParams().set("quoteNumber", this.commonService.commonMainObj.wqId)
    //                               .set("s3FileId", s3fileId)
    //                               .set("memberId",this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null)
    //                               .set("fileName",this.commonService.commonMainObj.uploadedFileName);
    // return this.httpClient.post<any>(this.Pcb_Quote_Url+"saveQuote?userId="+this.commonService.commonMainObj.userId+"&s3FileId="+s3fileId+"&fileName="+this.commonService.commonMainObj.uploadedFileName+"&quoteNumber="+this.commonService.commonMainObj.wqId+"memberId="+this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null,{headers: headers});

    return this.httpClient.post(Configuration.Pcb_Quote_Url+"saveQuote",sendFormData,{params:params});
  }

  getResaleInfoData(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
                                    .set("Accept", "application/json" );
    let params = {userID:this.commonService.commonMainObj.userId,wqId:this.commonService.commonMainObj.wqId };
    return this.httpClient.get<any>(Configuration.Order_Url+"/getOrderDetials",{headers: headers, params:params});
                                    
  }

  public checkUserSessionApi(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
    .set("Accept", "application/json" );
    let params = {memberId:this.commonService.commonMainObj.userSessionMemberId};
    // return this.httpClient.get<any>(this.backendStagingServer+"/checkUserSession",{headers: headers, params:params});
    return this.httpClient.get<any>(Configuration.backendStagingServer + "/session",{headers: headers,withCredentials:true});
  }

  updateAndResendNotAuth(updatedData:any){
    var params = {userID:this.commonService.commonMainObj.userId,orderId:this.commonService.commonMainObj.orderPlacedData.orderNumber,memberId:this.commonService.commonMainObj.userSessionMemberId ? this.commonService.commonMainObj.userSessionMemberId : null};
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" )
                      .set("Authorization", "bearer c5d1c152-ae3d-4ddd-a8b9-181943c2c9c9" );

    return this.httpClient.put(Configuration.oneFlowUrl+"/oneflow/updatePurchasingPersonDetails",updatedData,{headers: headers, params:params});
  }

  checkProductType(boardData:any,assemblyQtyNew:any,pcbQtyNew:any,pcbTT:any,assemblyTT:any){
    boardData.boardQty1 = pcbQtyNew
    if(assemblyQtyNew){
      var params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                  .set("assemblyQuantity", assemblyQtyNew)
                                  .set("assemblyTurntime", assemblyTT)
                                  .set("pcbTurntime", pcbTT);
      var paramsGuest = new HttpParams().set("emailId", this.commonService.commonMainObj.email)
                                        .set("assemblyQuantity", assemblyQtyNew)
                                        .set("assemblyTurntime", assemblyTT)
                                        .set("pcbTurntime", pcbTT);
    }else{
      var params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                    .set("pcbTurntime", pcbTT);
      var paramsGuest = new HttpParams().set("emailId", this.commonService.commonMainObj.email)
                                        .set("pcbTurntime", pcbTT);
    }
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    if(this.commonService.commonMainObj.userId){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"productType",boardData,{headers: headers, params:params});
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"productType",boardData,{headers: headers, params:paramsGuest});
    }
  }

  reQuoteCheck(quoteData:any,webQuote:any){
    var params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
                                  .set("webQuoteId", webQuote);
    var paramsGuest = new HttpParams().set("emailId", this.commonService.commonMainObj.email)
                                      .set("webQuoteId", webQuote);
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    if(this.commonService.commonMainObj.userId){
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"reQuote",quoteData,{headers: headers, params:params});
    }else{
      return this.httpClient.post(Configuration.Pcb_Quote_Url+"reQuote",quoteData,{headers: headers, params:paramsGuest});
    }
  }

  changeNewQuote(oldQuoteId:any,){
    var params = new HttpParams().set("userId", this.commonService.commonMainObj.userId)
                                  .set("wqId", oldQuoteId)
                                  .set("memberId", 'null');
    var paramsGuest = new HttpParams().set("emailId", this.commonService.commonMainObj.email)
                                      .set("wqId", oldQuoteId)
                                      .set("memberId", 'null');
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    if(this.commonService.commonMainObj.userId){
      return this.httpClient.get(Configuration.Pcb_Quote_Url+"getQuoteDetails",{headers: headers, params:params});
    }else{
      return this.httpClient.get(Configuration.Pcb_Quote_Url+"getQuoteDetails",{headers: headers, params:paramsGuest});
    }
  }

  public checkPaymentStatus(){
    var headers = new  HttpHeaders().set("Content-Type", "application/json" )
    .set("Accept", "application/json" );
    let params = {userId:this.commonService.commonMainObj.userId,orderId:this.commonService.commonMainObj.orderPlacedData.orderNumber};
    return this.httpClient.get<any>(Configuration.backendStagingServer+"/paymentStatus",{headers: headers, params:params});
  }

  generateQuoteBOM(bomData:any){
    return this.httpClient.post<any>(Configuration.REST_API_SERVER + "createAttachBOMPlain", bomData);
  }

  // checkCookieAPI(){
  //   return this.httpClient.get(this.commonService.commonMainObj.customerPortalUrl,{ responseType: 'text' as const});
  // }
  
   // Dashboard related API
   requestForActivityEntryInDb(uploadedFileData:any){
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    return this.httpClient.post(Configuration.oneFlowUrl+"/activity",uploadedFileData,{headers: headers});                  
  }

  getDashboardData(opt1:any,opt2:any,opt3:any,page:any){
    var itemSize = 15;
    var pageNum = page - 1;
    if(opt1 == 'email' && opt2 != '' ){
      return this.httpClient.get(Configuration.oneFlowUrl+"/activity/paginatedActivities?page="+pageNum+'&size='+itemSize+"&emailId="+opt2); 
    }else if(opt1 == 'product' && opt2 != ''){
      return this.httpClient.get(Configuration.oneFlowUrl+"/activity/paginatedActivities?page="+pageNum+'&size='+itemSize+"&productType="+opt2); 
    }else if(opt1 == 'date' && opt2 != '' && opt3 != ''){
      return this.httpClient.get(Configuration.oneFlowUrl+"/activity/paginatedActivities?page="+pageNum+'&size='+itemSize+"&fromDate="+opt2+'&toDate='+opt3); 
    }
    else{
      return this.httpClient.get(Configuration.oneFlowUrl+"/activity/paginatedActivities?page="+pageNum+'&size='+itemSize); 
    }
  }

  updateDetailsToDashboard(activityId:any,dataToUpdateInDashboard:any, pageName:any){
    var headers = new HttpHeaders().set("Content-Type","appplication/json")
                                    .set("Accept","application/json");
    return this.httpClient.put(Configuration.oneFlowUrl+"/activity/"+activityId+"/pages/"+pageName+"?parentActivityId="+this.commonService.commonMainObj.parentDashboardActivityId+'&activityDate='+this.commonService.commonMainObj.formattedDate,dataToUpdateInDashboard);
  }

  requestForCustomBomPricing(customBomData:any): Observable<any>{
    var headers = new  HttpHeaders()
                      .set("Content-Type", "application/json")
                      .set("Accept", "application/json" );
    return this.httpClient.post(Configuration.Pcb_Quote_Url+"bomPricing", customBomData,{headers:headers});
  } 

  getbomIssueResolutions(resolveData:any){
    var headers = new HttpHeaders().set("Content-Type","application/json")
    .set("Accept","application/json");
    var params = {userId:this.commonService.commonMainObj.userId}
    return this.httpClient.post(Configuration.Pcb_Quote_Url+"bomIssueResolutions", resolveData, {headers: headers, params:params});
  }

  submitMpnLevel1CheckToResolve(dataToValidate:any){
    var headers = new HttpHeaders().set("Content-Type","application/json")
    .set("Accept","application/json");
    return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+"validateCustomBomItems",dataToValidate,{headers: headers})
  }

  sierraSuggested(lineItemsArray:any){
    let headers = new HttpHeaders().set("Content-Type","application/json")
    .set("Accept","application/json");
    let params:any = {}
    if(this.commonService.commonMainObj.userId){
      params['userId'] = this.commonService.commonMainObj.userId
      params['bomId'] = this.commonService.commonMainObj.finalBomDataToPurchase.bomId
    }else{
      params['emailId'] = this.commonService.commonMainObj.email
      params['bomId'] = this.commonService.commonMainObj.finalBomDataToPurchase.bomId;
    }
    return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+"applyRecommendation",lineItemsArray,{headers: headers, params:params})
  }

  saveTheBomFile(bomFile:any){
    return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+"uploadBom",bomFile,{})
  }

  getSavedBomFIleData(fileName:any): Observable<any> {
    let params = {filename:fileName};
    return this.httpClient.get<any>(Configuration.Pcb_Quote_Url+"retrieveBom",{params:params,responseType: 'blob' as 'json', observe: 'response' as 'body' });
  }

  saveAppData(){
    let appObjData:any = {};
    let cntntData = this.commonService.commonMainObj.reQuoteContentObj?this.commonService.commonMainObj.reQuoteContentObj:'';
    this.commonService.commonMainObj.reQuoteContentObj = '';
    if(cntntData){
      delete cntntData._declarationLView
      delete cntntData._declarationTContainer
    }
    appObjData.data = {
      'commonDataObj' : JSON.stringify(this.commonService.commonMainObj),
      'apiSerDataObj' : JSON.stringify(this.apiMainObj),
      'contentObj': cntntData?cntntData:''
    }
    let headers = new HttpHeaders().set("Content-Type","application/json")
    .set("Accept","application/json");
    return this.httpClient.post<any>( Configuration.Pcb_Quote_Url+"localStorage",appObjData,{headers:headers});
  }

  getAppStoreData(appDtId:any){
    return this.httpClient.get<any>(Configuration.Pcb_Quote_Url+"localStorage/"+appDtId,{});
  }

  downloadZipFile(id:any,fileName:any){
    return this.httpClient.get<any>(Configuration.autoBOMFileDownloadUrl+id+".zip&expectedFileName="+fileName,{responseType: 'blob' as 'json', observe: 'response' as 'body' })
  }

  downloadBomFile(bomFileId:any){
     return this.httpClient.get<any>(Configuration.autoBOMFileDownloadUrl+bomFileId+'&isBom=True',{responseType: 'blob' as 'json', observe: 'response' as 'body' })
  }

  webSocketFileUploadAPI(formData:any){
    return this.httpClient.post<any>(Configuration.REST_API_SERVER + "validateEnhancedV2",formData,{});
  }
  
  webSocketAPI(formData:any,socketId:any){
    return this.httpClient.post<any>(Configuration.REST_API_SERVER + "uploadById?sid="+socketId,formData,{});
  }

  multiFileSocketFn(multiFileErrObj:any,socketId:any){
    return this.httpClient.post<any>(Configuration.REST_API_SERVER + "selectFolder?sid="+socketId,multiFileErrObj,{});
  }
    // creating the entry
    createDataForActivityEntry(){
      var pActivityId;
      var source = '';
      var activityDataObj:any = {
        "activityId": this.commonService.commonMainObj.fileId,
        "parentActivityId": this.commonService.commonMainObj.parentDashboardActivityId?this.commonService.commonMainObj.parentDashboardActivityId:null,
        "emailId": this.commonService.commonMainObj.isGuestUser == false ? this.commonService.commonMainObj.userData.registrationEmail : this.commonService.commonMainObj.email,
        "source":this.commonService.commonMainObj.fromWhereReupload != '' ? 'File Re-upload': 'Portal Home Page',
        "guestUser": this.commonService.commonMainObj.isGuestUser == true ? 'true':'false',
        "designFileName":this.commonService.commonMainObj.uploadedFileName,
        "uploadFileDetailsPage":{
            "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
          }
      }
      this.requestForActivityEntryInDb(activityDataObj).subscribe((res: any)=>{
        this.commonService.commonMainObj.dashBoardActivityId=res.activityId;
        // OFP-3961 fix
        if(res.parentActivityId == null){
          this.commonService.commonMainObj.parentDashboardActivityId = res.activityId
        }
      },error =>{
        console.log('Error in creating entry in db', error);   
      })
      if(this.commonService.commonMainObj.userSessionMemberId){
        setTimeout(()=>{
          // this.sessionPortalLoad();
          this.checkUserSessionApi().subscribe((data: any)=>{  
          },error =>{
            console.log('Error in checking user session', error);   
          })
        },800);
      }
    }

  //get dasshboard summary data
  getDashboardSummaryData(fromDate:any,toDate:any){
    return this.httpClient.get(Configuration.oneFlowUrl+"/activity/dashboard/summary?from="+fromDate+'&to='+toDate); 
  }
  checkProductTypeForQuotes(boardData:any){
    // var params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    return this.httpClient.post(Configuration.Pcb_Quote_Url+"genericProductType",boardData,{headers: headers});
  }

  adminDashBoardLogin(loginData:any){
    // var params = new HttpParams().set("userID", this.commonService.commonMainObj.userId)
    var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
    return this.httpClient.post(Configuration.oneFlowUrl+"/activity/login",loginData,{headers: headers});
  }

  callAPIToSendCapturedEvent(data:any){
    const url = Configuration.oneFlowUrl+'/marketo/customerAction';
    navigator.sendBeacon(url, data)
  }
  
  updateSessionTimeSpent(activityId:any,pageName:any){
    const url = Configuration.oneFlowUrl+"/activity/"+activityId+"/pages/"+pageName+"?parentActivityId="+this.commonService.commonMainObj.dashBoardActivityId;
    this.commonService.commonMainObj.sessionLastTimeOut = new Date();
    const initilaTime = this.commonService.commonMainObj.sessionFirstTimeIn instanceof Date ? this.commonService.commonMainObj.sessionFirstTimeIn:new Date(this.commonService.commonMainObj.sessionFirstTimeIn);
    this.commonService.commonMainObj.totalSessionTimeSpent = this.commonService.commonMainObj.sessionLastTimeOut - initilaTime;
    this.commonService.formatTotalSessionTimeSpent(this.commonService.commonMainObj.totalSessionTimeSpent);
    var totalTimeSpent ={
      "sessionTotalTimeSpent": this.commonService.commonMainObj.formattedSessionTimeSpent
    }
    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(totalTimeSpent),
      keepalive: true
    });
  }

 getPendingPaymentMessage(orderNumber:any){
  var headers = new HttpHeaders().set("Content-Type", "application/json" )
                      .set("Accept", "application/json" );
  var params = {userID:this.commonService.commonMainObj.userId,orderNumber:(orderNumber).split("-")[0]}
    return this.httpClient.get(Configuration.Pcb_Quote_Url + 'getPendingPaymentMessage',{headers: headers, params:params});
 }
}
